export var Size;
(function (Size) {
    Size["s"] = "s";
    Size["m"] = "m";
})(Size || (Size = {}));
